// extracted by mini-css-extract-plugin
export default {"box":"box__Mlpjt","disabled":"disabled__eXc5y","active":"active__wWdjY","focus":"focus__DTaUX","action":"action__ggTue","toggle":"toggle__Q-hn6","input":"input__4gDwW"};